import {Condition, InputField} from '@/model/types';

export const coalesceReadonlyIf = (field: InputField): boolean | Condition[] | undefined => {
  if (field.type === 'hidden') return true;
  if ('readonlyIf' in field) return field.readonlyIf;
  if ('readonly' in field) return field.readonly;
  return undefined;
};

export const coalesceDisabledIf = (field: InputField): boolean | Condition[] | undefined => {
  if ('disabledIf' in field) return field.disabledIf;
  if ('disabled' in field) return field.disabled;
  return undefined;
};

export const coalesceRequiredIf = (field: InputField): boolean | Condition[] | undefined => {
  if ('requiredIf' in field) return field.requiredIf;
  if ('required' in field) return field.required;
  return undefined;
};
